/*
 * Shared TypedTable styling classes. Keep these as plain CSS class names so
 * table callers can decorate rows/cells without changing cell value shapes.
 */
export const DIMMABLE_TABLE_CELL_CLASS = "typed-table-cell--dimmable";
export const DIMMED_TABLE_CELL_CLASS = "typed-table-cell--dimmed";
export const DIMMED_TABLE_ROW_CLASS = "typed-table-row--dimmed";

export type TableRowClassNameData = {
  readonly className?: string;
};

export const isDimmedTableRow = (
  rowData: TableRowClassNameData | undefined
): boolean => {
  return rowData?.className === DIMMED_TABLE_ROW_CLASS;
};
